var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAfinandinhoPlanoDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "afinandinho_plano_prata 1",
    clipPath: "url(#clip0_7001_1536)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.80591 40.1441C5.80591 57.9291 22.6243 58.9399 26.4846 58.9399C27.0026 58.9399 27.527 58.9399 28.0451 58.9399C31.899 58.9399 48.7237 57.9227 48.7237 40.1441C48.7237 22.1506 31.5073 21.3229 27.9187 21.3482C27.4828 21.3482 27.0532 21.3482 26.6172 21.3482C23.0287 21.3229 5.81223 22.1506 5.81223 40.1441H5.80591Z",
    fill: "url(#paint0_linear_7001_1536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M46.7532 40.1445C46.7532 43.4045 46.1404 46.216 44.9147 48.56C43.6069 46.0454 41.6041 44.0742 38.9126 42.6464C34.6354 40.3846 29.8906 40.1445 28.0458 40.1445H27.9257C27.7046 40.1445 27.4835 40.1445 27.2623 40.1445C27.0412 40.1445 26.8201 40.1445 26.599 40.1445H26.4789C24.6341 40.1445 19.8893 40.3909 15.6121 42.6464C12.9206 44.0679 10.9178 46.0454 9.61001 48.56C8.39064 46.216 7.77148 43.4045 7.77148 40.1445C7.77148 33.3906 10.4124 28.57 15.6121 25.8154C19.8893 23.5536 24.6341 23.3135 26.4789 23.3135H26.599C26.8201 23.3135 27.0412 23.3135 27.2623 23.3135C27.4835 23.3135 27.7046 23.3135 27.9257 23.3135H28.0458C29.8906 23.3135 34.6354 23.5599 38.9126 25.8154C44.1123 28.5637 46.7532 33.3843 46.7532 40.1445Z",
    fill: "url(#paint1_linear_7001_1536)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.3052 27.4139V14.9612C50.5941 14.5758 51.4912 13.268 51.2196 11.8022C51.0174 10.7092 50.1392 9.8247 49.0399 9.62253C47.2961 9.30031 45.7672 10.6334 45.7672 12.3266C45.7672 13.5712 46.5948 14.62 47.7321 14.9612V27.338C45.7861 24.634 43.3474 22.8397 41.1109 21.6582C35.9049 18.9036 30.2377 18.6066 28.039 18.6066H27.8811C27.6726 18.6066 27.4641 18.6066 27.2556 18.6066C27.0471 18.6066 26.8323 18.6066 26.6112 18.6066H26.4659C24.2672 18.6066 18.6 18.9036 13.394 21.6582C11.1954 22.8207 8.80721 24.5708 6.87392 27.199V14.9612C8.16278 14.5758 9.05993 13.268 8.78826 11.8022C8.58608 10.7092 7.70789 9.8247 6.60857 9.62253C4.86482 9.30031 3.33587 10.6334 3.33587 12.3266C3.33587 13.5712 4.16352 14.62 5.30075 14.9612V27.4139C2.36923 27.4139 0 29.7894 0 32.7146V36.2527C0 37.3393 0.442257 38.3186 1.14987 39.0326C1.66162 39.5443 2.31237 39.9171 3.04525 40.0813C3.32956 40.1508 3.6265 40.1824 3.92976 40.1824H4.61842V40.1445C4.61842 30.1622 9.79281 25.3353 14.1332 23.0418C19.0296 20.4515 24.3936 20.1735 26.4722 20.1735H26.6112C27.0408 20.1735 27.4767 20.1735 27.8937 20.1735H28.039C30.1176 20.1735 35.4816 20.4515 40.3717 23.0418C44.7121 25.3353 49.8865 30.1685 49.8865 40.1445V40.1824H50.6699C50.9416 40.1824 51.2006 40.1571 51.4533 40.1066C52.2241 39.9487 52.9128 39.5696 53.4435 39.0326C54.1574 38.3186 54.5933 37.3393 54.5933 36.2527V32.7146C54.5933 29.7831 52.2178 27.4139 49.2926 27.4139H49.3052ZM4.92168 12.3203C4.92168 11.6695 5.45238 11.1388 6.10313 11.1388C6.75388 11.1388 7.28459 11.6695 7.28459 12.3203C7.28459 12.971 6.75388 13.5017 6.10313 13.5017C5.45238 13.5017 4.92168 12.971 4.92168 12.3203ZM47.3403 12.3203C47.3403 11.6695 47.8711 11.1388 48.5218 11.1388C49.1726 11.1388 49.7033 11.6695 49.7033 12.3203C49.7033 12.971 49.1726 13.5017 48.5218 13.5017C47.8711 13.5017 47.3403 12.971 47.3403 12.3203Z",
    fill: "#662D91"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M36.3657 30.0166H18.2585C12.9478 30.0166 8.64258 34.3203 8.64258 39.6294C8.64258 44.9383 12.9478 49.2421 18.2585 49.2421H36.3657C41.6764 49.2421 45.9816 44.9383 45.9816 39.6294C45.9816 34.3203 41.6764 30.0166 36.3657 30.0166Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M27.3127 44.245C26.7252 44.245 26.1502 44.1439 25.6006 43.9481C25.2278 43.8154 25.0383 43.4047 25.1709 43.0383C25.3036 42.6655 25.7143 42.476 26.0807 42.6087C26.8641 42.8867 27.755 42.8867 28.5384 42.6087C28.9112 42.476 29.3155 42.6719 29.4482 43.0383C29.5809 43.4111 29.385 43.8154 29.0186 43.9481C28.4752 44.1439 27.9003 44.245 27.3064 44.245H27.3127Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M18.9537 41.2697C20.3181 41.2697 21.424 40.1637 21.424 38.7994C21.424 37.4351 20.3181 36.3291 18.9537 36.3291C17.5894 36.3291 16.4834 37.4351 16.4834 38.7994C16.4834 40.1637 17.5894 41.2697 18.9537 41.2697Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M35.6717 41.2697C37.036 41.2697 38.142 40.1637 38.142 38.7994C38.142 37.4351 37.036 36.3291 35.6717 36.3291C34.3074 36.3291 33.2014 37.4351 33.2014 38.7994C33.2014 40.1637 34.3074 41.2697 35.6717 41.2697Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7001_1536",
    x1: 27.2617,
    y1: 21.3482,
    x2: 27.2617,
    y2: 58.9399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7001_1536",
    x1: 27.2623,
    y1: 23.3135,
    x2: 27.2623,
    y2: 48.56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6E6E6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7001_1536"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54.9661,
    height: 59.3887,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfinandinhoPlanoDefault);
export default __webpack_public_path__ + "static/media/afinandinho_plano_default.df30d33365a21fb41852ce67f5f1e14b.svg";
export { ForwardRef as ReactComponent };